import { Component } from 'react'
import PropTypes from 'prop-types'

class LazyComponent extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    component: null,
    waitForReducers: !!this.props.reducers,
    loadedReducers: false,
    waitForSagas: !!this.props.sagas,
    loadedSagas: false,
  }

  componentDidMount() {
    // Use class properties to avoid waiting for setState to execute
    this.mounted = true

    if (this.props.reducers) this.loadReducers()
    if (this.props.sagas) this.loadSagas()

    this.loadComponent()
  }

  componentWillUnmount() {
    this.mounted = false
  }

  async loadComponent() {
    const { default: component } = await this.props.loader()
    // Make sure to verify that the component is still valid,
    // otherwise an error will be thrown
    if (this.mounted) this.setState({ component })
  }

  async loadReducers() {
    const { default: dynamicReducer } = await this.props.reducers()
    // Make sure to verify that the component is still valid,
    // otherwise an error will be thrown
    if (this.mounted) {
      if (!this.props.componentName) {
        // eslint-disable-next-line no-console
        console.error('Supply a componentName to LazyComponent to register reducers')
        return
      }

      this.context.store.registerReducer(this.props.componentName, dynamicReducer)
      this.setState({ loadedReducers: true })
    }
  }

  async loadSagas() {
    const { default: dynamicSaga } = await this.props.sagas()
    // Make sure to verify that the component is still valid,
    // otherwise an error will be thrown
    if (this.mounted) {
      if (!this.props.componentName) {
        // eslint-disable-next-line no-console
        console.error('Supply a componentName to LazyComponent to register sagas')
        return
      }

      this.context.store.registerSaga(this.props.componentName, dynamicSaga)
      this.setState({ loadedSagas: true })
    }
  }

  render() {
    const { component, waitForReducers, loadedReducers, waitForSagas, loadedSagas } = this.state
    const { children } = this.props

    // If we have to wait for the reducer to be loaded and it's not ready, don't send the component
    if (waitForReducers && !loadedReducers) return children(null)

    // If we have to wait for the sagas to be loaded and they're not ready, don't send the component
    if (waitForSagas && !loadedSagas) return children(null)

    return children(component)
  }
}

LazyComponent.propTypes = {
  componentName: PropTypes.string,
  loader: PropTypes.func.isRequired,
  reducers: PropTypes.func,
  sagas: PropTypes.func,
  children: PropTypes.func,
}

LazyComponent.contextTypes = {
  store: PropTypes.shape({}),
}

export default LazyComponent
